export default "__VITE_ASSET__DbxQePrZ__"